module.exports = __webpack_public_path__ + "static/media/product_640-5.bf8840bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product_640-5.jpg
// module id = 2388
// module chunks = 0